import React from 'react'

const ColourUtils = () => {
    const getHashCode = function (str) {
        var hash = 0;
        if (str.length === 0) return hash;
        for (var i = 0; i < str.length; i++) {
            hash = str.charCodeAt(i) + ((hash << 5) - hash);
            hash = hash & hash; // Convert to 32bit integer
        }
        return hash;
    };
    const intToHSL = function (num) {
        var shortened = num % 360;
        return "hsl(" + shortened + ",100%,30%)";
    };

    const getCssColour = (str) => {
        const hash = getHashCode(str)
        const hsl = intToHSL(hash)
        return "color: " + hsl
    }

    const stringToHue = (str) => {
        const hash = getHashCode(str)
        return hash % 360;
    }

    return {
        getCssColour    : getCssColour,
        stringToHue     : stringToHue
    }
}

export default ColourUtils
